import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';


/**
 * APIL Url: ADAC.Internet.Core.Models.Schadenmeldung.Aks.SchadenAksDatenPerson
 * Container für alle persönlichen Daten und weiteren Versicherungen
 * Endpoints: /api/schadenmeldungen/aks
 */
export class SchadenAksDatenPersonApi extends BaseApiModel {
	constructor(initialProperties?: Partial<SchadenAksDatenPersonApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected vorname: string;
	/**
	 * Description: Vorname des Antragssteller
	 * APIL Type: string
	 */
	get Vorname(): string {
		return this.vorname;
	}

	/**
	 * Description: Vorname des Antragssteller
	 * APIL Type: string
	 */
	set Vorname(value: string) {
		this.vorname = value;
	}

	protected nachname: string;
	/**
	 * Description: Nachname des Antragssteller
	 * APIL Type: string
	 */
	get Nachname(): string {
		return this.nachname;
	}

	/**
	 * Description: Nachname des Antragssteller
	 * APIL Type: string
	 */
	set Nachname(value: string) {
		this.nachname = value;
	}

	protected firma: string;
	/**
	 * Description: Name der Firma die den Antrag stellt
	 * APIL Type: string
	 */
	get Firma(): string {
		return this.firma;
	}

	/**
	 * Description: Name der Firma die den Antrag stellt
	 * APIL Type: string
	 */
	set Firma(value: string) {
		this.firma = value;
	}

	protected beguenstigter: string;
	/**
	 * Description: Nachname des Begünstigten bei einer Firma
	 * APIL Type: string
	 */
	get Beguenstigter(): string {
		return this.beguenstigter;
	}

	/**
	 * Description: Nachname des Begünstigten bei einer Firma
	 * APIL Type: string
	 */
	set Beguenstigter(value: string) {
		this.beguenstigter = value;
	}

	protected mitgliedsnummer: string;
	/**
	 * Description: Mitgliedsnummer des Antragssteller
	 * APIL Type: string
	 */
	get Mitgliedsnummer(): string {
		return this.mitgliedsnummer;
	}

	/**
	 * Description: Mitgliedsnummer des Antragssteller
	 * APIL Type: string
	 */
	set Mitgliedsnummer(value: string) {
		this.mitgliedsnummer = value;
	}

	protected strasse: string;
	/**
	 * Description: Strasse mit Hausnummer beim Wohnort des Antragssteller
	 * APIL Type: string
	 */
	get Strasse(): string {
		return this.strasse;
	}

	/**
	 * Description: Strasse mit Hausnummer beim Wohnort des Antragssteller
	 * APIL Type: string
	 */
	set Strasse(value: string) {
		this.strasse = value;
	}

	protected plz: string;
	/**
	 * Description: Plz beim Wohnort des Antragssteller
	 * APIL Type: string
	 */
	get Plz(): string {
		return this.plz;
	}

	/**
	 * Description: Plz beim Wohnort des Antragssteller
	 * APIL Type: string
	 */
	set Plz(value: string) {
		this.plz = value;
	}

	protected ort: string;
	/**
	 * Description: Wohnort des Antragssteller
	 * APIL Type: string
	 */
	get Ort(): string {
		return this.ort;
	}

	/**
	 * Description: Wohnort des Antragssteller
	 * APIL Type: string
	 */
	set Ort(value: string) {
		this.ort = value;
	}

	protected email: string;
	/**
	 * Description: Email des Antragssteller
	 * APIL Type: string
	 */
	get Email(): string {
		return this.email;
	}

	/**
	 * Description: Email des Antragssteller
	 * APIL Type: string
	 */
	set Email(value: string) {
		this.email = value;
	}

	protected telefonVorwahl: string;
	/**
	 * Description: Vorwahl des Antragssteller
	 * APIL Type: string
	 */
	get TelefonVorwahl(): string {
		return this.telefonVorwahl;
	}

	/**
	 * Description: Vorwahl des Antragssteller
	 * APIL Type: string
	 */
	set TelefonVorwahl(value: string) {
		this.telefonVorwahl = value;
	}

	protected telefonNummer: string;
	/**
	 * Description: Telefonnummer des Antragssteller
	 * APIL Type: string
	 */
	get TelefonNummer(): string {
		return this.telefonNummer;
	}

	/**
	 * Description: Telefonnummer des Antragssteller
	 * APIL Type: string
	 */
	set TelefonNummer(value: string) {
		this.telefonNummer = value;
	}

	protected kontoinhaber: string;
	/**
	 * Description: Kontoinhaber der Bankverbindung
	 * APIL Type: string
	 */
	get Kontoinhaber(): string {
		return this.kontoinhaber;
	}

	/**
	 * Description: Kontoinhaber der Bankverbindung
	 * APIL Type: string
	 */
	set Kontoinhaber(value: string) {
		this.kontoinhaber = value;
	}

	protected iban: string;
	/**
	 * Description: IBAN der Bankverbindung
	 * APIL Type: string
	 */
	get Iban(): string {
		return this.iban;
	}

	/**
	 * Description: IBAN der Bankverbindung
	 * APIL Type: string
	 */
	set Iban(value: string) {
		this.iban = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): SchadenAksDatenPersonApi {
		return AppUtils.Helper.createFromMap(dataObject, SchadenAksDatenPersonApi, (key, value) => {
			switch (key.toLowerCase()) {

				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Vorname = this.vorname;
		result.Nachname = this.nachname;
		result.Firma = this.firma;
		result.Beguenstigter = this.beguenstigter;
		result.Mitgliedsnummer = this.mitgliedsnummer;
		result.Strasse = this.strasse;
		result.Plz = this.plz;
		result.Ort = this.ort;
		result.Email = this.email;
		result.TelefonVorwahl = this.telefonVorwahl;
		result.TelefonNummer = this.telefonNummer;
		result.Kontoinhaber = this.kontoinhaber;
		result.Iban = this.iban;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}